import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook that scrolls to top of the page when the route changes
 */
export function useScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
}

/**
 * Utility function to scroll to top programmatically
 */
export function scrollToTop() {
  window.scrollTo(0, 0);
}

export default useScrollToTop;
